module.exports = __webpack_public_path__ + "img/icon-cerrar-sesion.7b1c3500.svg";